import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import moment from "moment";

export default class ManagementBookingSearch extends Component {
  render() {
    const {
      cabangOptions,
      selectedCabang,
      onSearchChange,
      startBookingDate,
      endBookingDate,
      onSearch,
      onFilterClick,
    } = this.props;
    return (
      <React.Fragment>
        <FlexView vAlignContent="center" style={{ gap: "75px" }}>
          <p className="margin margin-bottom-15px">Cabang</p>
          <SimpleDDL
            id="select_options_nama_cabang"
            box="search"
            name="selectedCabang"
            containerclassname="width width-280px"
            placeholder="Nama cabang hak akses"
            options={cabangOptions}
            value={selectedCabang}
            onChange={(value, { name }) => onSearchChange(name, value)}
          />
        </FlexView>
        <FlexView
          vAlignContent="center"
          style={{ justifyContent: "space-between" }}
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <p className="margin margin-bottom-15px">Tanggal Booking</p>
            <SimpleDate
              id="select_start_date"
              name="startBookingDate"
              nextdate
              containerclassname="width width-280px"
              date={startBookingDate}
              maxDate={endBookingDate}
              onChange={(value) =>
                onSearchChange(
                  "startBookingDate",
                  moment(value).format("DD-MM-YYYY")
                )
              }
            />
            <p className="margin margin-bottom-15px">s/d</p>
            <SimpleDate
              id="select_endDate"
              name="endBookingDate"
              backdate
              containerclassname="width width-280px"
              date={endBookingDate}
              minDate={startBookingDate}
              onChange={(value) =>
                onSearchChange(
                  "endBookingDate",
                  moment(value).format("DD-MM-YYYY")
                )
              }
            />
            <SimpleButton
              className="margin margin-bottom-20px"
              text="CARI"
              onClick={() => onSearch()}
            />
          </FlexView>
          <Button
            type="button"
            onClick={() => onFilterClick()}
            className="btn background-red margin-bottom-20px"
          >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
          </Button>
        </FlexView>
      </React.Fragment>
    );
  }
}
